module.exports = __webpack_public_path__ + "img/5.d7797de7.png";